/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddWeightDto,
  GetWeightsParams,
  WeightEntryDto,
  WeightSeriesDto
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAddWeightUrl = () => {




  return `/api/weight`
}

/**
 * Weigh-ins are append-only history; the goal keeps its own `startWeightKg` and is not rewritten by a new entry.
 * @summary Record a weigh-in
 */
export const addWeight = async (addWeightDto: AddWeightDto, options?: Parameters<typeof apiFetch>[1]): Promise<WeightEntryDto> => {

  return apiFetch<WeightEntryDto>(getAddWeightUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addWeightDto)
  }
);}





export const getAddWeightMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWeight>>, TError,{data: AddWeightDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addWeight>>, TError,{data: AddWeightDto}, TContext> => {

const mutationKey = ['addWeight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWeight>>, {data: AddWeightDto}> = (props) => {
          const {data} = props ?? {};

          return  addWeight(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddWeightMutationResult = NonNullable<Awaited<ReturnType<typeof addWeight>>>
    export type AddWeightMutationBody = AddWeightDto
    export type AddWeightMutationError = unknown

    /**
 * @summary Record a weigh-in
 */
export const useAddWeight = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWeight>>, TError,{data: AddWeightDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addWeight>>,
        TError,
        {data: AddWeightDto},
        TContext
      > => {
      return useMutation(getAddWeightMutationOptions(options), queryClient);
    }
    export const getGetWeightsUrl = (params: GetWeightsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/weights?${stringifiedParams}` : `/api/weights`
}

/**
 * @summary Weigh-in series with a fitted trendline
 */
export const getWeights = async (params: GetWeightsParams, options?: Parameters<typeof apiFetch>[1]): Promise<WeightSeriesDto> => {

  return apiFetch<WeightSeriesDto>(getGetWeightsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWeightsQueryKey = (params?: GetWeightsParams,) => {
    return [
    `/api/weights`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWeightsQueryOptions = <TData = Awaited<ReturnType<typeof getWeights>>, TError = unknown>(params: GetWeightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeights>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeightsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeights>>> = ({ signal }) => getWeights(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWeightsQueryResult = NonNullable<Awaited<ReturnType<typeof getWeights>>>
export type GetWeightsQueryError = unknown


export function useGetWeights<TData = Awaited<ReturnType<typeof getWeights>>, TError = unknown>(
 params: GetWeightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeights>>,
          TError,
          Awaited<ReturnType<typeof getWeights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeights<TData = Awaited<ReturnType<typeof getWeights>>, TError = unknown>(
 params: GetWeightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeights>>,
          TError,
          Awaited<ReturnType<typeof getWeights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeights<TData = Awaited<ReturnType<typeof getWeights>>, TError = unknown>(
 params: GetWeightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeights>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Weigh-in series with a fitted trendline
 */

export function useGetWeights<TData = Awaited<ReturnType<typeof getWeights>>, TError = unknown>(
 params: GetWeightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeights>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWeightsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






